export default __webpack_public_path__ + "static/media/triangle-mains.d4904fb9.png";